(function ($, Drupal, once) {
  Drupal.behaviors.accordionWrapper = {
    attach(context) {
      const dls = context.querySelectorAll('.ckeditor-accordion-container dl');

      dls.forEach(dl => {
        if (dl.dataset.accordionWrapped) return;
        dl.dataset.accordionWrapped = 'true';

        let current = null;

        Array.from(dl.children).forEach(node => {
          if (node.nodeName === 'DT') {
            current = node;
          } else if (node.nodeName === 'DD' && current) {
            const wrapper = document.createElement('div');
            wrapper.classList.add('accordion-item');
            dl.insertBefore(wrapper, current);
            wrapper.appendChild(current);
            wrapper.appendChild(node);
            current = null;
          }
        });
      });
    }
  };
}(jQuery, Drupal, once));
